import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";

interface ActiveBadgeProps {
  isActive: boolean;
}

export function ActiveBadge({ isActive }: ActiveBadgeProps) {
  const { t } = useTranslation("admin-users");
  if (isActive) {
    return <Badge variant="success">{t("badges.active")}</Badge>;
  }
  return <Badge variant="muted">{t("badges.deactivated")}</Badge>;
}
